import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';
@Injectable({
  providedIn: 'root'
})
export class TaskService {
 
  get baseUrl(): string { return Constants.CORE_API_BASE_URL; }
  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }



constructor(private http: HttpClient) { }
getPlantsData(data: any): Observable<any[]> {
  return this.http.post<any[]>(this.O3CoreApiUrl + 'Common/GetDepartments', data);
  }
getMasterProject(data: any):Observable<any[]> {
  return this.http.post<any[]>(this.O3CoreApiUrl + 'project/GetMasterProjects', data);
  }
getMasterTopic(data: any): Observable<any[]> {
 // return this.http.post<any[]>(this.kpiBaseUrl +'mastertopic' ,data)
 return this.http.post<any[]>(this.O3CoreApiUrl + 'Topic/GetMasterTopics', data);
}
addTask(data: any): Observable<any[]> {
  // return this.http.post<any[]>(this.kpiBaseUrl + 'addtask', data );
  return this.http.post<any[]>(this.O3CoreApiUrl + 'Task/AddTask', data);
  }
getMasterTask(data:any):Observable<any[]>{
  // return this.http.post<any[]>(this.kpiBaseUrl +'mastertask' ,data)
  return this.http.post<any[]>(this.O3CoreApiUrl + 'Task/GetMasterTasks', data);
}
getMasterFrequencies(data: any): Observable<any[]> {
  // return this.http.get<any[]>(this.kpiBaseUrl +'taskfrequency' )
  return this.http.get<any[]>(this.O3CoreApiUrl + 'Task/GetFrequency' )
}
GetOneMasterTask(data: any): Observable<any> {
  // return this.http.post<any>(this.kpiBaseUrl + 'task', data );
  return this.http.post<any>(this.O3CoreApiUrl + 'Task/GetOneTask', data );
}
deleteTask(data: any): Observable<any> {
  // return this.http.post<any>(this.kpiBaseUrl + 'deletetask', data );
  return this.http.post<any>(this.O3CoreApiUrl + 'Task/DeleteTask', data);
}
updateTask(data: any): Observable <any[]> {;
  // return this.http.put<any[]>(this.kpiBaseUrl + 'task', data );
  return this.http.put<any[]>(this.O3CoreApiUrl + 'Task/UpdateTask', data );
}

getTpoicProject(data: any): Observable<any[]> {

  return this.http.post<any[]>(this.O3CoreApiUrl + 'topic/getAllTopicByProject', data);
  }
}
